import $ from 'jquery';
import AOS from 'aos';
import Utag from './js/cmpUtag';
/*eslint-disable */
import slick from 'slick-carousel';
import braSizes from './js/braFinderCalculatorSizes';
import tingle from 'tingle.js';
import Brightcove from './js/cmpBrightcoveVideo';

export default class Feature {
  constructor() {
    this.example = 'example';
    this.currentEssentialSlide = 0;
    this.currentFixesSlide = 0;
    this.windowTestSwitch = true;
  }

  init() {
    Feature.initCarousels();
    this.initNav();
    this.initCalculator();
    this.setEssentialSlide(0);
    this.setFixesSlide(0);
    AOS.init();
    setTimeout(()=> {
      this.initUtag();
      const v = new Brightcove(this.utag);
      v.init();
    }, 400);
  }
  initUtag() {
    this.utag = new Utag({
      call_page_tags: false,
      use_attribute_tags: true,
      attribute_tag: 'utag',
    });
    this.utag.fireTag('view', {
      page_type: 'marketing',
      page_name: 'bra-fit-guide',
    });
  }
  initModal() {
    /*eslint-disable */
    const modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: 'Close',
      cssClass: ['apptModal'],
    });
    /* eslint-enable */
    $('.bfg-book .bfg-button').on('click', () => {
      modal.setContent('<iframe frameborder="0" scrolling="no" name="tt-lb-frme" allow="geolocation" style="width: 100%; height: 583px; position: relative; z-index: 300002; border: none;" src="https://timetrade.com/app/bloomingdales/workflows/bloomingdales005/schedule/?&amp;appointmentTypeGroupId=shopping_services&amp;ch=BCOM_ASLP&amp;view=embed"></iframe>');
      modal.open();
    });
  }
  initNav() {
    const _this = this;

    $('.bfg-nav').find('a').on('click', function (e) {
      e.preventDefault();
      $([document.documentElement, document.body]).animate({
        scrollTop: $($(this).attr('href')).offset().top - 100,
      }, 1000);
    });

    $('.bfg-essential').find('nav a').on('click', function (e) {
      e.preventDefault();
      _this.setEssentialSlide($(this).index());
    });

    $('.bfg-fixes').find('nav a').on('click', function (e) {
      e.preventDefault();
      _this.setFixesSlide($(this).index());
    });

    $('.bfg-essentials-carousels .cmp-arrow-next').on('click', () => {
      if ($(window).width() > 700 && _this.windowTestSwitch) {
        if (_this.currentEssentialSlide < 7) {
          _this.setEssentialSlide(_this.currentEssentialSlide + 1);
        } else {
          _this.setEssentialSlide(0);
        }
      } else {
        const carousel = $('.bfg-essentials-carousels .bfg-car.active .carousel');
        const slideIndex = $('.bfg-essentials-carousels .bfg-car.active .slick-slide.slick-active').index();
        const totalSlides = $('.bfg-essentials-carousels .bfg-car.active .slick-slide').length;
        if (slideIndex < (totalSlides - 1)) {
          carousel.slick('slickNext');
        } else if (_this.currentEssentialSlide < 7) {
          _this.setEssentialSlide(_this.currentEssentialSlide + 1);
        } else {
          _this.setEssentialSlide(0);
        }
      }
    });

    $('.bfg-essentials-carousels .cmp-arrow-previous').on('click', () => {
      if ($(window).width() > 700 && _this.windowTestSwitch) {
        if (_this.currentEssentialSlide > 0) {
          _this.setEssentialSlide(_this.currentEssentialSlide - 1);
        } else {
          _this.setEssentialSlide(7);
        }
      } else {
        const carousel = $('.bfg-essentials-carousels .bfg-car.active .carousel');
        const slideIndex = $('.bfg-essentials-carousels .bfg-car.active .slick-slide.slick-active').index();
        if (slideIndex > 0) {
          carousel.slick('slickPrev');
        } else if (_this.currentEssentialSlide > 0) {
          _this.setEssentialSlide(_this.currentEssentialSlide - 1, true);
        } else {
          _this.setEssentialSlide(7, true);
        }
      }
    });

    $('.bfg-fixes-carousels .cmp-arrow-next').on('click', () => {
      if (_this.currentFixesSlide < 3) {
        _this.setFixesSlide(_this.currentFixesSlide + 1);
      } else {
        _this.setFixesSlide(0);
      }
    });

    $('.bfg-fixes-carousels .cmp-arrow-previous').on('click', () => {
      if (_this.currentFixesSlide > 0) {
        _this.setFixesSlide(_this.currentFixesSlide - 1);
      } else {
        _this.setFixesSlide(3);
      }
    });
  }
  setFixesSlide(index) {
    this.currentFixesSlide = index;
    const carousel = $('.bfg-car-fitfixes .carousel');

    $('.bfg-fixes nav a.active').removeClass('active');
    $('.bfg-fixes nav a').eq(index).addClass('active');
    carousel.slick('slickGoTo', index, false);
  }
  setEssentialSlide(index, lastSlide) {
    this.currentEssentialSlide = index;
    const carouselOuter = $('.bfg-essential .bfg-car').eq(index);
    const carousel = $('.bfg-essential .carousel').eq(index);
    const totalSlides = $('.bfg-essentials-carousels .bfg-car.active .slick-slide').length;

    $('.bfg-essential nav a.active').removeClass('active');
    $('.bfg-essential nav a').eq(index).addClass('active');
    $('.bfg-essential .bfg-car').addClass('hideFade').removeClass('active');

    // set carousel
    carouselOuter.addClass('active').removeClass('hideFade');

    // reset slick
    carousel.slick('setPosition');

    if (lastSlide) {
      carousel.slick('slickGoTo', (totalSlides - 1), true);
    } else {
      carousel.slick('slickGoTo', 0, true);
    }

    // set essential buttons
    $('.cfg-essentials-btns').find('a').addClass('hide');
    $('.cfg-essentials-btns').find('a').eq(index).removeClass('hide');
  }
  initCalculator() {
    const bandSizes = [...new Set(braSizes.map(x => x.band))];
    this.buildFilter('.cfg-select-band', bandSizes);
    $('.cfg-select-band').on('change', () => {
      this.setBandChange();
    });
    $('.cfg-select-bust').on('change', () => {
      this.setBustChange();
    });
  }
  setBandChange() {
    $('.cfg-select-bust').html('<option value="">Your bust size</option>');
    this.buildBustFilter(this.getFilterValue('.cfg-select-band'));
  }
  setBustChange() {
    this.getBraSize(this.getFilterValue('.cfg-select-band'), this.getFilterValue('.cfg-select-bust'));
  }
  getBraSize(band, bust) {
    const result = braSizes.filter(obj => (obj.band === parseInt(band, 10) && obj.bust === parseInt(bust, 10)));
    $('.cfg-input-size').val(result[0].bra);
  }
  buildBustFilter(val) {
    const bustSizes = [...new Set(braSizes.filter(x => x.band === parseInt(val, 10)).map(x => x.bust))];
    this.buildFilter('.cfg-select-bust', bustSizes);
  }
  buildFilter(el, array) {
    array.forEach((val) => {
      $(el).append(`<option value="${val}">${val}</option>`);
    });
  }
  getFilterValue(el) {
    return $(el).children('option:selected').val();
  }

  static initCarousels() {
    AOS.refreshHard();
    const carouselBreakpoint = [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1, fade: true, slidesToScroll: 1, arrows: false, dots: false,
        },
      },
    ];

    $('.bfg-car').each(function () {
      let slidesToShow = 3;
      let slidesToScroll = 3;
      const breakpoint = carouselBreakpoint;
      const adaptiveHeight = false;

      if ($(this).hasClass('bfg-car-minimizer') || $(this).hasClass('bfg-car-pushup')) {
        slidesToShow = 2;
        slidesToScroll = 2;
      }

      $(this).removeClass('hide');
      if ($(this).hasClass('bfg-car-fitfixes')) {
        $(this).find('.carousel').slick({
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          lazyLoad: 'progressive',
          adaptiveHeight,
          fade: true,
          arrows: false,
        });
      } else {
        $(this).find('.carousel').slick({
          speed: 500,
          slidesToShow,
          slidesToScroll,
          infinite: false,
          lazyLoad: 'progressive',
          responsive: breakpoint,
          adaptiveHeight,
        });
      }
      $(this).addClass('hide');
    });

    $('.bfg-essentials-carousels').find('.bfg-car').each(function () {
      $(this).addClass('hideFade').removeClass('hide');
    });

    $('.bfg-car-fitfixes').removeClass('hide');

    $('.bfg-car-tshirt').removeClass('hideFade').removeClass('hide');
  }
  static resetCarousels() {
    $('.bfg-car').each(function () {
      $(this).find('.carousel').slick('setPosition');
    });
  }
}



// WEBPACK FOOTER //
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_bcom/package/src/braFitGuide.js